import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import mainBase from '@/assets/config/mainBase'
import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap,{
// // ak 是在百度地图开发者平台申请的密钥详见 ht
// ak:'A8a77a5a829c83eb17d77902b800c538&services=&t=20180323140107'
// })
Vue.config.productionTip = false
//项目的全局配置文件
Vue.use(mainBase)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
